<template>
    <div>
        <span class="label">{{ label }}</span>
        <v-row v-if="!chip" :dense="dense">
            <v-col :cols="cols" :md="colsMd" v-for="(item, i) in itemsMap" :key="i">
                <v-btn
                    :class="['normal-btn pa-0', {'disable-events': readonly}]"
                    class="kimsa-elevation" block
                    :height="height" :outlined="outlined"
                    :color="colorBtn(item.value)"
                    @click="clickBtn(item.value)"
                >
                    <div v-if="withIcon">
                        <v-icon :size="item.size_icon" :color="model === item.value ? 'white' : color">
                            {{ item.icon }}
                        </v-icon>
                        <br>
                        <div class="item-name">
                            {{ item.name }}
                        </div>
                    </div>
                    <div v-else-if="withImages">
                        <v-img
                            :height="height/1.5"
                            :width="height/1.5"
                            eager class="mx-auto"
                            :lazy-src="imgPlaceholder"
                            :src="image(item.src)"
                        />
                        <div class="item-name">
                            {{ item.name }}
                        </div>
                    </div>
                    <div v-else>
                        {{ item.name }}
                    </div>
                </v-btn>

            </v-col>
        </v-row>
        <v-chip v-else v-for="(item, i) in itemsMap" :key="i"
                :class="['mr-2 my-1', {'disable-events': readonly}, {'tile': tile}, {'bordered': bordered}]"
                label :color="item.color" @click="clickBtn(item.value)">
            {{ item.name }}
        </v-chip>
    </div>
</template>

<script>
export default {
    name: "KimsaSelect",
    props: {
        color: {
            type: String,
            default: 'secondary'
        },
        label: {
            type: String,
            default: ''
        },
        height: {
            type: Number,
            default: 0
        },
        elevation: {
            type: Number,
            default: 0
        },
        items: {
            type: Array,
            default: () => []
        },
        values: {
            type: Array,
            default: () => []
        },
        withIcon: {
            type: Boolean,
            default: false
        },
        withImages: {
            type: Boolean,
            default: false
        },
        multiple: {
            type: Boolean,
            default: false
        },
        chip: {
            type: Boolean,
            default: false
        },
        tile: {
            type: Boolean,
            default: false
        },
        readonly: {
            type: Boolean,
            default: false
        },
        cols: {
            type: [String, Number],
            default: '6'
        },
        outlined: {
            type: Boolean,
            default: false,
        },
        bordered: {
            type: Boolean,
            default: false,
        },
        dense: {
            type: Boolean,
            default: false,
        },
        colsMd: {
            type: [String, Number],
            default: undefined
        }
    },
    data() {
        return {
            model: '',
            array: [],
        }
    },
    mounted() {
        const vm = this
        setTimeout(function () {
            vm.setDefaults()
        }, 300)
    },
    methods: {
        colorBtn(value) {
            const vm = this
            let color = vm.outlined ? '' : 'transparent'
            if (vm.multiple) {
                return vm.array.includes(value) ? vm.color : color
            } else {
                return vm.model === value ? vm.color : color
            }
        },
        clickBtn(value) {
            const vm = this
            if (vm.multiple) {
                vm.array.includes(value) ? vm.array.splice(vm.array.indexOf(value), 1) : vm.array.push(value)
            } else {
                vm.model = value
            }
        },
        image(src) {
            try {
                return require(`@/assets/${src}`);
            } catch (e) {
                return src
            }
        },
        setDefaults() {
            const vm = this
            // console.log('kimsa select defaults', vm.values)
            if (vm.values.length > 0) vm.array = vm.values
        },
        reset() {
            const vm = this
            vm.array = []
            vm.model = ''
        }
    },
    computed: {
        itemsMap() {
            const vm = this
            return vm.items.map(item => {
                item.color = vm.colorBtn(item.value)
                return item
            })
        }
    },
    watch: {
        model(val) {
            const vm = this
            if (!vm.multiple) vm.$emit('change', val)
        },
        array(val) {
            const vm = this
            if (vm.multiple) vm.$emit('change', val)
        },
        values() {
            this.setDefaults()
        }
    }
}
</script>

<style scoped>

.label {
    font-size: 15px;
    color: #707070;
}

.disable-events {
    pointer-events: none
}

.tile {
    border-radius: 0 !important;
    border: 1px solid rgba(204, 204, 204, .5) !important;
}

.bordered {
    border: 1px solid rgba(102, 204, 204, 0.5) !important;
}

.item-name {
    font-size: 11px;
    line-height: 18px;
}

</style>